import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';

import { hostsKeys } from '@/features/hosts/api/query-keys/hosts';

export const useRemoveHost = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['hosts']);

  return useMutation({
    mutationFn: (hostId: number) => hostsApi.removeHost(hostId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: hostsKeys.lists(),
      });
      onSuccess?.();
      toast.success(t('hosts:dialogs.remove.success'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
